import React from 'react';

import {
    Clear as CloseIcon,
} from '@mui/icons-material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {Button, ButtonBase, Stack, Typography} from '@mui/material';
import {Box} from '@mui/system';

import {imageUrl} from 'lib/media';

const styles = {
    menuHeader: {
        width: '100%',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        backgroundColor: 'black.dark',
        zIndex: 1100,
        flexShrink: 0,
        height: '60px',
    },
    menuHeaderButton: {
        color: 'white.main',
        cursor: 'pointer',
        justifyContent: 'flex-start',
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        flexShrink: 0,
        minWidth: 50,
        width: 50,
        height: 50,
        paddingLeft: 2.5,
    },
    menuHeaderImageContainer: {
        marginRight: '10px',

        '& img': {
            borderRadius: '10px',
            display: 'block',
            borderColor: 'white.main',
            borderWidth: 2,
            borderStyle: 'solid',
        }
    },
    menuHeaderButtonLast: {
        justifyContent: 'flex-end',
        paddingRight: 2.5,
    },
    menuHeaderTextContainer: {
        flexGrow: 1,
        overflow: 'hidden',
    },
};

const MenuHeader = ({text, handleBackButton, handleClose, image}) => {
    return (
        <Stack sx={styles.menuHeader} direction="row">

            {handleBackButton &&
                <ButtonBase sx={styles.menuHeaderButton} onClick={handleBackButton} disableRipple>
                    <ArrowBackIosIcon />
                </ButtonBase>
            }

            <Stack sx={styles.menuHeaderTextContainer} flexDirection="row" justifyContent="center" alignItems="center">
                {image && <Box sx={styles.menuHeaderImageContainer}><img src={imageUrl(image, {h: 36})} /></Box>}
                <Typography align="center" variant="h4" color="white.main">{text}</Typography>
            </Stack>

            {handleClose && <Button sx={[styles.menuHeaderButton, styles.menuHeaderButtonLast]} disableRipple onClick={handleClose}>
                <CloseIcon/>
            </Button>}

        </Stack>
    );
};

export default MenuHeader;